import theme_icons from '../../icons.js';
import { MediaUploaderGeneric } from '../../components/image-picker-generic.js';


const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, InnerBlocks, ColorPalette } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl, TextareaControl } = wp.components;

const imagewithtext = {
  title: 'Image and Text Block',
  icon: theme_icons.greenheart,
  category: 'greenheart',
  supports: {
    align: ['wide', 'full']
  },
  //attributes
  attributes: {
    flip: {
      type: 'boolean',
      default: false
    },
    texture: {
      type: 'text',
      default: 'sand',  // sand, paint, torn-paper
    },
    backgroundColor:{
        type: 'text',
        default: ''
    },
    imageone: {
      type: 'object',
      default: {}
    },
    isContainer:{
        type: 'boolean',
        default: true
    },
    isTicker: {
      type: 'boolean',
      default: false
    },
    isContain: {
      type: 'boolean',
      default: false
    },
    tickerText: {
      type: 'text',
      default: 'Breaking News: ...'
    },
    tickerColor: {
      type: 'text',
      default: ''
    },
    title: {
      type: 'text',
    },
    titleColor: {
        type: 'text',
        default: ''
    },
    subtitle: {
      type: 'text',
    },
    subTitleColor: {
        type: 'text',
        default: ''
    }

  },

  edit({ attributes, setAttributes }) {
    const { flip, texture, imageone, title, titleColor, subtitle, subTitleColor, backgroundColor, isContain, isContainer, isTicker, tickerText, tickerColor } = attributes;

    function handleImageOneChange(imageObject) {
      setAttributes({ imageone: imageObject });
    }
    function onTitleChange(text) {
      setAttributes({ title: text });
    }
    function onSubtitleChange(text) {
      setAttributes({ subtitle: text });
    }

    return ([
      <InspectorControls>
        <PanelBody title={'Section Properties'}>
            <p><strong>Background Color</strong></p>
            <p style={{color:"#666"}}>If you set a Background Color, you will need to set light/dark title & subtitle colors</p>
            <ColorPalette
              value={backgroundColor}
              onChange={(colorValue) => setAttributes({ backgroundColor: colorValue })}
            />
        
            <h4><strong>Text Colors</strong></h4>
            <p>Title Color:</p>
            <ColorPalette
                label="Title Color"
                value={titleColor}
                onChange={(colorValue) => setAttributes({ titleColor: colorValue })}
            />
            <p>Subtitle Color:</p>
            <ColorPalette
                label="Subtitle Color"
                value={subTitleColor}
                onChange={(colorValue) => setAttributes({ subTitleColor: colorValue })}
            />
      
          <p><strong>Layout: Image Orientation</strong></p>
          <ToggleControl
            label="Image Left?"
            checked={flip}
            onChange={() => setAttributes({ flip: !flip })}
            help={flip ? 'Image on the left' : 'Image on the right'}
          />
            <p><strong>Layout: Pull Image to the Edge?</strong></p>
            <ToggleControl
                label={isContainer ? "Image has margins" : "Image stretches to the edge"}
                checked={isContainer}
                onChange={() => setAttributes({ isContainer: !isContainer })}
                help={isContainer ? 'When the block is set to Full Width align - the background color stretches to the edge but the image keeps its margins' : 'When the block is set to Full Width align - the image stretches to the edge'}

            />
          <p><strong>Add an Urgent Message Ticker?</strong></p>
          <ToggleControl
            checked={isTicker}
            onChange={() => setAttributes({ isTicker: !isTicker })}
          />
          {
            isTicker ? <><p><strong>News Ticker Text:</strong></p>
              <TextareaControl value={tickerText} onChange={(newtext) => { setAttributes({ tickerText: newtext }) }} /> </>

              : null}
          {isTicker ? <>
            <p><strong>News Ticker Color:</strong></p>
            <ColorPalette
              value={tickerColor}
              onChange={(colorValue) => setAttributes({ tickerColor: colorValue })}
            />
          </>

            : null}

          <p><strong>Image Display:</strong></p>
          <ToggleControl
            checked={isContain}
            onChange={() => setAttributes({ isContain: !isContain })}
            help={isContain ? 'The whole image will be displayed (Contain)' : 'The image will be cropped to fill the layout (Cover)'}
            label={isContain ? 'No crop' : 'Default crop'}
          />

          <p><strong>Texture:</strong></p>
          <SelectControl
            label="Pick Background Texture"
            value={texture}
            options={[
              { label: "None", value: "none" },
              { label: "Sand", value: "sand" },
              { label: "Paint Splash", value: "paint" },
              { label: "Torn Paper", value: "torn-paper" }
            ]}
            onChange={(val) => setAttributes({ texture: val })}
          />

        </PanelBody>
      </InspectorControls>,
      <section className={isContainer ? "has-container" : "no-container"} style={{backgroundColor:backgroundColor}}>
        <div className={flip ? "editor-layout-grid flipped" : "editor-layout-grid"} >

            <div className="block-flex-area">
                {isTicker ? <div className="ticker-wrap"><div className="ticker-text">{tickerText}</div></div> : null}

                <RichText
                    tagName="h2"
                    className="block-title"
                    value={title}
                    onChange={onTitleChange}
                    placeholder={'Lorem ipsum dolor sit amet,'}
                    allowedFormats={['core/bold', 'core/italic']}
                    style={{ color: titleColor }}
                />
                <RichText
                    tagName="h4"
                    className="block-subtitle"
                    value={subtitle}
                    onChange={onSubtitleChange}
                    placeholder={'Consectetur adipiscing elit.'}
                    allowedFormats={['core/bold', 'core/italic']}
                    style={{ color: subTitleColor }}
                />
                <div className="inner-blocks-wrap">
                    <InnerBlocks />
                </div>
                <div className={"texture " + texture}></div>
            </div>
          <div className={"image-flex-area"}>
            <div className="image-one">
              <MediaUploaderGeneric photo={imageone} buttonPosition="left" updateImage={handleImageOneChange} isContain={isContain} />
            </div>
            
          </div>
        </div>
      </section>
    ]);
  },
  save({ attributes }) {
    const { flip, texture, imageone, title, titleColor, subtitle, subTitleColor, backgroundColor, isTicker, isContain, isContainer, tickerText, tickerColor } = attributes;
    const generateSourceSetSquare = (media, desiredWidth) => {

      const sizes = media.mediaSizes;
      let srcset = [];

      if (isContain) { //only uncropped thumbs
        console.log("sizes", sizes);
        srcset = [sizes['mobile-page-header']?.url ?? null];

      } else {

        for (const size in sizes) {
          if (sizes.hasOwnProperty(size) && size.includes('square')) {
            const width = sizes[size].width;
            if (width >= desiredWidth) {
              srcset.push(`${sizes[size].url} ${width}w`);
            }
          }
        }

    }

      return srcset.length ? srcset.join(', ') : '';
    }
    const generateSourceSetLandscape = (media, desiredWidth) => {

      const sizes = media.mediaSizes;
      let srcset = [];
      if (isContain) { //only uncropped thumbs

        srcset = [sizes['mobile-page-header']?.url ?? null];

      } else {

        for (const size in sizes) {
          if (sizes.hasOwnProperty(size) && size.includes('landscape')) {
            const width = sizes[size].width;
            if (width >= desiredWidth) {
              srcset.push(`${sizes[size].url} ${width}w`);
            }
          }
        }

      }
      return srcset.length ? srcset.join(', ') : '';
    }
    const generateBlock = () =>{
        return(
            <div className={flip ? "layout flipped" : "layout"} style={backgroundColor ? {backgroundColor:backgroundColor} : {backgroundColor:"transparent"}} >
            <div className="block-flex-area">
              {isTicker && <div className="ticker-wrap ">
                <RichText.Content
                  tagName="div"
                  className="ticker-text"
                  style={{ color: tickerColor ?? '#321321' }}
                  value={tickerText}
                /></div>
              }

              <RichText.Content
                tagName="h2"
                className="block-title"
                value={title}
                style={{ color: titleColor }}
              />
              <RichText.Content
                tagName="h4"
                className="block-subtitle"
                value={subtitle}
                style={{ color: subTitleColor }}
              />
              <div className={"inner-blocks-wrap"}>
                <InnerBlocks.Content />
              </div>
              <div className={"texture " + texture}></div>
            </div>
            <div className={"image-flex-area"}>
              <div className="image-one">
                <img src={imageone.mediaUrl} srcSet={generateSourceSetSquare(imageone, 475)} loading="lazy" alt={title + " collage image"} style={isContain ? { backgroundSize: "contain", height: "auto" } : { backgroundSize: "cover" }} />
              </div>
              
            </div>
          </div>
        )
    }

    return (
      <section>
        {!isContainer ? generateBlock() : <div className="theme-container">{generateBlock()}</div> }
      </section>
    )
  }
};
registerBlockType('rbt/imagewithtext', imagewithtext);
export default imagewithtext;